import handlebarsUtils from './handlebars-utils';

class SideNavItem {
	constructor (public id: string, public title: string) {

	}
}

export class SideNavBuilder {
	private readonly sideBarTemplate =
		`<nav id="navbar-data-container" class="sticky-top sticky-top-stacked navbar navbar-light bg-light">
			<nav class="nav nav-pills flex-column">
				{{#each sideNavItems}}
				<a class="nav-link" href="#{{id}}">{{title}}</a>
				{{/each}}
			</nav>
		</nav>`;

	private sideNavTemplate = handlebarsUtils.compileTemplateFromText(this.sideBarTemplate);

	public render (fieldsetSelector: string, sideNavPlacementSelector: string) {
		const context = {
			sideNavItems: Array.from(document.querySelectorAll(fieldsetSelector))
				.map(e => {
					const id = e.id;
					const title = e.querySelector('legend')!.textContent || id;
					return new SideNavItem(id, title);
				})
		};

		const content = this.sideNavTemplate(context);
		$(sideNavPlacementSelector).html(content);
		$('body').scrollspy({ target: '#navbar-data-container', offset: 50 });
	}
}
